export enum PermissionEnum {
  //parent
  USER = 'all::user',
  USER_ROLE = 'all::userRole',
  USER_PERMISSION = 'all::userPermission',
  AUDIT_LOGS = 'all::auditLogs',

  // User Management
  MANAGE_USER = 'manage::user',
  VIEW_USER = 'view::user',
  RESEND_ACTIVATION_USER = 'sendActivation::user',

  // User Role Management
  MANAGE_USER_ROLE = 'manage::userRole',
  VIEW_USER_ROLE = 'view::userRole',

  //User Permission
  MANAGE_USER_PERMISSION = 'manage::userPermission',
  VIEW_USER_PERMISSION = 'view::userPermission',

  //Audit Log Management
  VIEW_AUDIT_LOGS = 'view::auditLogs',

  // System Specific Permissions
  BASKETS = 'all::baskets',
  PRODUCTS = 'all::products',
  PRESENTATION = 'all::presentation',
  PRODUCT_CATEGORIES = 'all::productCategories',
  PRICES = 'all::prices',
  ANALYTICS = 'all::analytics',
  INSPECTIONS = 'all::inspections',
  ALERTS = 'all::alerts',
  NEWSLETTERS = 'all::newsletters',
  NEWS = 'all::news',
  ESTABLISHMENTS = 'all::establishments',

  // Bucket
  VIEW_BASKETS = 'view::baskets',
  MANAGE_BASKETS = 'manage::baskets',

  // Product
  VIEW_PRODUCTS = 'view::products',
  CREATE_PRODUCTS = 'create::products',
  UPDATE_PRODUCTS = 'update::products',
  DELETE_PRODUCTS = 'delete::products',
  CREATE_PRESENTATION = 'create::presentation',
  UPDATE_PRESENTATION = 'update::presentation',
  DELETE_PRESENTATION = 'delete::presentation',
  VIEW_PRESENTATION = 'view::presentation',

  // Product Category
  VIEW_PRODUCT_CATEGORIES = 'view::productCategories',
  MANAGE_PRODUCT_CATEGORIES = 'manage::productCategories',

  // Price
  VIEW_PRICES = 'view::prices',
  REPORT_PRICES = 'report::prices',
  UPDATE_PRICES = 'update::prices',
  DELETE_PRICES = 'delete::prices',

  // Analytics
  VIEW_ANALYTICS = 'view::analytics',
  MANAGE_ANALYTICS = 'manage::analytics',

  // Price requests
  MANAGE_PRICE_REQUESTS = 'all::reviewPrices',
  VIEW_PRICE_REQUESTS = 'view::reviewPrices',
  REVIEW_PRICE_REQUESTS = 'review::reviewPrices',

  // Inspection
  VIEW_INSPECTIONS = 'view::inspections',
  CREATE_INSPECTIONS = 'create::inspections',
  RUN_INSPECTIONS = 'run::inspections',
  UPDATE_INSPECTIONS = 'update::inspections',
  DELETE_INSPECTIONS = 'delete::inspections',

  // Alerts
  VIEW_ALERTS = 'view::alerts',
  CONFIG_ALERTS = 'config::alerts',
  VIEW_CONFIG_ALERTS = 'viewConfig::alerts',

  // External Data Upload
  MANAGE_EXTERNAL_DATA = 'all::externalData',
  UPLOAD_EXTERNAL_DATA = 'create::externalData',

  // Newsletter
  MANAGE_NEWSLETTERS = 'manage::newsletters',

  // News
  MANAGE_NEWS = 'manage::news',

  // Establishments
  VIEW_ESTABLISHMENTS = 'view::establishments',
  MANAGE_ESTABLISHMENTS = 'manage::establishments',
}

export enum PermissionGuardEmbedTypeEnum {
  SECTION = 'section',
  COMPONENT = 'component',
}
